import { Form, Upload, Button, Input, Divider,Radio  } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import React, {useEffect, useContext, useState, useMemo} from 'react';
import { Settings } from './settings';
import {ApiHost} from "@/config";
import { Resizer,FormContext } from 'wsc-react-custom-form';
import {getLayout} from "../mini-helper";

const defaultProps = {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    fillSpace: 'no',
    padding: ['0', '0', '0', '0'],
    margin: ['0', '0', '0', '0'],
    background: { r: 255, g: 255, b: 255, a: 1 },
    color: { r: 0, g: 0, b: 0, a: 1 },
    shadow: 0,
    radius: 0,
    width: '100%',
    height: 'auto',
    name: 'radio',
    label: '单选框',
    showLabel: 'true',
    disabled: 'false',
    required: 'true',
    visible: 'true',
    rules: [{required: true, message:'单选框'}],
    labelSpan: 6,
    labelOffset: 0,
    wrapperSpan: 18,
    wrapperOffset: 0,
    multiple: 'false',
    isNewLine: 'false',
    border: 'true',
};

export const MiniFormRadio  = (props) => {
    props = {
        ...defaultProps,
        ...props,
    };
    const {
        flexDirection,
        alignItems,
        justifyContent,
        fillSpace,
        background,
        color,
        padding,
        margin,
        shadow,
        radius,
        name,
        label,
        labelSpan,
        labelOffset,
        wrapperSpan,
        wrapperOffset,
        rules,
        visible,
        isNewLine,
        border,
        required,
        disabled,
    } = props;

    const { form, formdata } = useContext(FormContext);

    const itemLayout = getLayout(isNewLine, labelSpan, labelOffset, wrapperSpan, wrapperOffset);
    // 支持自定义校验
    const isRequired = required === 'true' || rules?.some(
        rule => typeof rule !== "function" && rule.required
    );

    return (<Resizer
        propKey={{ width: 'width', height: 'height' }}
        style={{
            justifyContent,
            flexDirection,
            alignItems,
            background: `rgba(${background.r}, ${background.g}, ${background.b}, ${background.a})})`,
            color: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
            padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
            margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
            boxShadow:
                shadow === 0
                    ? 'none'
                    : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
            borderRadius: `${radius}px`,
            flex: fillSpace === 'yes' ? 1 : 'unset',
            display: visible === 'true' ? 'flex': "none",
        }}
    >
        <Form.Item
            style={{ width: "100%" }}
            {...itemLayout}
            name={name}
            label={label}
            rules={rules}
            required={isRequired}
        >
            <Radio  disabled={disabled==='true'}/>

            { border === 'true' ? <Divider style={{margin: '8px 0 0'}}/> : null }
        </Form.Item>
    </Resizer>);
};


MiniFormRadio .craft = {
    displayName: 'Radio',
    props: {
        ...defaultProps
    },
    related: {
        toolbar: Settings,
    },
};

MiniFormRadio .Icon = () => {
    return (<span>单选框</span>);
}